import _str from "shared/util/_str";

export const DESCRIPTIONS = [
	{
		header: _str("Step into the spotlight"),
		paragraph: _str("We’ve supercharged Boost so you get more likes faster."),
	},
	{
		header: _str("Save yourself (a lot) of time"),
		paragraph: _str("Get a day’s worth of attention in one 30-minute Boost."),
	},
];



// WEBPACK FOOTER //
// ./src/apps/boosts/util/constants.js